module.exports = __webpack_public_path__ + "img/guandao.05d2223e.png";